document.addEventListener("DOMContentLoaded", () => {
    const splideElement = document.querySelector(".splide-our-categories");
    const ourCategoriesParent = document.querySelector(".our-categories-parent");
    const ourCategoriesSlider = new Splide(splideElement, {
        perPage: 6,
        pagination: true,
        arrows: true,
        gap: 24,
        classes: {
        arrows: 'splide__arrows splide-awards-our-categories-arrows',
        arrow : 'splide__arrow splide-awards-our-categories-arrow',
        prev  : 'splide__arrow--prev splide-categories-prev',
        next  : 'splide__arrow--next splide-categories-next',
        },
         breakpoints: {
             1024: {
            perPage: 4,
        },990: {
            destroy:'completely'
        },
        
      },
      arrowPath: "M22 13.7344L20.6 15.1844L24.15 18.7344H12V20.7344H24.15L20.6 24.2844L22 25.7344L28 19.7344L22 13.7344Z",
    });

    ourCategoriesSlider.mount();

    // Check only the real slides (not clones)
    const realSlideCount = splideElement.querySelectorAll(".splide__slide:not(.is-clone)").length;

    if (realSlideCount < 7) {
        ourCategoriesSlider.destroy(true);
        ourCategoriesParent.classList.add("fallback-grid"); // apply grid layout
        console.log("Splide destroyed — not enough real slides.");
    }
});
